// extracted by mini-css-extract-plugin
export default {"content":"RedirectLink_content__TIsdv","redirectLink":"RedirectLink_redirectLink__O9s1b"};